export default __webpack_public_path__ + "locales/fi/SharingPanel.json?hash=f976fb7ec4ecb087c0d3b2469b669e57";